var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b(
      {
        attrs: { id: "underwater-" + _vm._uid },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function() {
                return [
                  _vm.layers
                    ? [
                        _c("rect", {
                          attrs: {
                            x: "0",
                            y: "0",
                            width: "1384",
                            height: "2200",
                            fill: "#015191"
                          }
                        }),
                        _c("rect", {
                          attrs: {
                            x: "0",
                            y: "0",
                            width: "1384",
                            height: "1500",
                            fill: "#42A7B0"
                          }
                        }),
                        _c("layer", {
                          attrs: { layer: _vm.layers["background"] }
                        }),
                        _vm._t("default"),
                        _c("repeat", {
                          attrs: { repeat: 7000, keyframe: _vm.keyframe },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(visible) {
                                  return [
                                    _c("layer", {
                                      attrs: {
                                        layer: _vm.layers["yellowfish"],
                                        x: -700 + visible.keyframe / 4,
                                        my: 0.4,
                                        mx: 1,
                                        y: 100
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3658538016
                          )
                        }),
                        _c("delay", {
                          attrs: { start: 300, keyframe: _vm.octopusKeyframe },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(visible) {
                                  return [
                                    _c("layer", {
                                      attrs: {
                                        layer: _vm.layers["octopus"],
                                        y: -1200 + visible.keyframe / 2,
                                        color: "blue",
                                        x: -300 + visible.keyframe / 2
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2890288702
                          )
                        }),
                        _c("repeat", {
                          attrs: { repeat: 7000, keyframe: _vm.keyframe },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(visible) {
                                  return [
                                    _c("layer", {
                                      attrs: {
                                        layer: _vm.layers["bigfish"],
                                        x: 700 - visible.keyframe / 4,
                                        my: 0.5,
                                        y: 125
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2947004375
                          )
                        }),
                        _c("repeat", {
                          attrs: { repeat: 8000, keyframe: _vm.keyframe },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(visible) {
                                  return [
                                    _c("layer", {
                                      attrs: {
                                        layer: _vm.layers["yellowfish"],
                                        x: -900 + visible.keyframe / 4,
                                        my: 0.2,
                                        mx: 1.8,
                                        y: 0
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3159388607
                          )
                        }),
                        _c("repeat", {
                          attrs: { repeat: 8000, keyframe: _vm.keyframe },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(visible) {
                                  return [
                                    _c("layer", {
                                      attrs: {
                                        layer: _vm.layers["bigfish"],
                                        x: 1900 - visible.keyframe,
                                        y: 400,
                                        my: 0,
                                        mx: 1.5
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2323911938
                          )
                        }),
                        _c("layer", {
                          attrs: { layer: _vm.layers["foreground"] }
                        })
                      ]
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      },
      "vector",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }